export const STORE_SESSION_TRANSCRIPT_SUMMARY = 'STORE_SESSION_TRANSCRIPT_SUMMARY';
export const CLEAR_SESSION_TRANSCRIPT_SUMMARY = 'CLEAR_SESSION_TRANSCRIPT_SUMMARY';
